module.exports = __webpack_public_path__ + "assets/img/9-1.15311785.png";